(function(konto) {
	konto.ke = {};
} (konto = window.konto));
